// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"10353":"f34f3f7ca47d3f30","97917":"c9ec4f1e6e994991"}[chunkId] + ".css";
};